<template>
  <!-- 选择目的地 -->
  <div>
    <el-cascader :style="cascaderWidth"
                 size="mini"
                 :show-all-levels="showAllLevels"
                 v-model="destSelected"
                 :options="option"
                 :props="selectDestProp"
                 clearable
                 :placeholder="placeholder"
                 @change="destChange"
                 filterable></el-cascader>
  </div>
</template>

<script>
export default {
  name: 'select-dest',
  data() {
    return {
      cascaderWidth: `width: ${this.selectInputWidth}px`,
      destSelected: this.destShowBack,
      option: [],
      selectDestProp: {
        // checkStrictly: true,
        checkStrictly: false,
        emitPath: this.cbPath, // 返回数组 还是 节点值 默认 节点id
        label: 'loc_name', // 选项的名字
        value: 'loc_id', // 选项返回的 值
        children: 'children', // 指定选项的子选项为选项对象的某个属性值
      },
    }
  },
  props: {
    cbPath: {
      type: Boolean,
      default: false,
    },
    showAllLevels: {
      type: Boolean,
      default: false,
    },

    //
    destShowBack: {
      type: Number,
      default: null,
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    selectInputWidth: {
      type: Number,
      default: 200,
    },
  },
  watch: {
    // 通过 ID 反显示 目的地
    destShowBack(newValue) {
      this.destSelected = newValue
    },
    // // 是否联动
    // strictlyCheck(newValue) {
    //   this.selectDestProp.checkStrictly = newValue
    // },
  },
  mounted() {
    this.loadDest()
  },
  methods: {
    destChange() {
      this.$emit('selectDest', this.destSelected)
    },
    loadDest() {
      this.$http.get('/get_dest_level').then((res) => {
        // console.log(res)
        this.option = res.data.data
      })
    },
  },
}
</script>

<style>
</style>